import type { GlobalSideBetStatus } from '@/types/side-bets';

export interface SideBetStatusBadge {
  label: string;
  classes: string;
}

export function getSideBetStatusBadge(status: GlobalSideBetStatus): SideBetStatusBadge {
  switch (status) {
    case 'open':
      return { label: 'ממתין', classes: 'bg-secondary text-muted-foreground' };
    case 'locked':
      return { label: 'נעול', classes: 'bg-blue-500/15 text-blue-400' };
    case 'pending_review':
      return { label: 'ממתין לאישור', classes: 'bg-yellow-400/10 text-yellow-400/80' };
    case 'resolved':
      return { label: 'הושלם', classes: 'bg-secondary text-muted-foreground' };
    default:
      return { label: 'ממתין', classes: 'bg-secondary text-muted-foreground' };
  }
}

export interface SideBetResolutionInput {
  status: GlobalSideBetStatus;
  selected_option: string;
  other_text: string | null;
  correct_answer: string | null;
}

/**
 * A side bet pick is "correct" only when the parent bet is resolved AND the
 * user's selected option matches the correct answer. For `other` picks, the
 * user's free-text answer (other_text) is what's compared.
 */
export function isSideBetCorrect(pick: SideBetResolutionInput): boolean {
  if (pick.status !== 'resolved' || !pick.correct_answer) return false;
  if (pick.selected_option === 'other') {
    return !!pick.other_text && pick.other_text === pick.correct_answer;
  }
  return pick.selected_option === pick.correct_answer;
}
